<ng-container *ngIf="!!ids && { infos: (sponsorInfos | sortByIds: ids:'sponsorId') } as vars">
  <add-manage-wrapper *ngIf="displayType === displayTypes.narrowPod" titleIcon="sponsor18" [hideHRule]="true" class="performer-list" wrapperTitle="Sponsors" [openLabel]="readOnly ? '' : '+ ADD A SPONSOR'" (open)="addSponsorsToASession($event)">
    <ng-container *ngIf="sessionInfo">
      <div class="empty-text" *ngIf="noSponsors">{{ emptyText }}</div> <!-- This is not completely correct -->
      <ng-container *ngFor="let sInfo of vars.infos; trackBy: trackByPInfo">
        <status-wrapper 
          *ngIf="sponsors[sInfo.sponsorId] as sponsor" [status]="sInfo.status || sponsorStatus.Pending"
          [logoUrl]="sponsor.logoUrl"
          [readOnly]="readOnly"
          [threeDotOptions]="threeDotOptions"
          [statusOptions]="statusOptions"
          (threeDotSelection)="dotMenuSelection($event, sponsor)"
          (changeStatus)="changeStatus(sInfo.sponsorId, $event)">
          <div class="boldContent">{{ sponsors[sInfo.sponsorId].name }}</div>
        </status-wrapper>
      </ng-container>
    </ng-container>
  </add-manage-wrapper>
  <add-manage-wrapper 
    cdkDropList
    class="performer-list wide"
    *ngIf="displayType === displayTypes.widePod" 
    [titleIcon]="'sponsor18'" 
    [hideHRule]="true"  
    [wrapperTitle]="'Sponsors'" 
    [openLabel]="readOnly ? '' : '+ ADD A SPONSOR'" 
    (open)="addSponsorsToASession($event)"
    (cdkDropListDropped)="dropSponsorIds($event)"
  >
    <ng-container *ngIf="sessionInfo">
      <div class="empty-text" *ngIf="noSponsors">{{ emptyText }}</div> <!-- This is not completely correct -->
      <ng-container *ngFor="let sInfo of vars.infos; trackBy: trackByPInfo">
        <div class="drag-wrapper" cdkDrag *ngIf="sponsors[sInfo.sponsorId] as sponsor">
          <icon class="handle" matIcon="drag_indicator" cdkDragHandle></icon>
          <status-wrapper
            [status]="sInfo.status || sponsorStatus.Pending" 
            [ngClass]="{ clickable: !readOnly }"
            (click)="readOnly ? null : editSponsor(sponsor)"
            [wideFormat]="true"
            [logoUrl]="sponsor.logoUrl"
            [readOnly]="readOnly"
            [threeDotOptions]="threeDotOptions"
            [statusOptions]="statusOptions"
            (threeDotSelection)="dotMenuSelection($event, sponsor)"
            (changeStatus)="changeStatus(sInfo.sponsorId, $event)">
            <div class="wideContent">{{ sponsors[sInfo.sponsorId].name }}</div>
          </status-wrapper>
        </div>
      </ng-container>
    </ng-container>
  </add-manage-wrapper>
  <div class="read-only-holder" *ngIf="displayType === displayTypes.readOnly && vars.infos.length">
    <h5>SPONSORS</h5>
    <ng-container *ngFor="let sInfo of vars.infos; trackBy: trackByPInfo">
      <sponsor-card class="read-only-card" *ngIf="sponsors[sInfo.sponsorId]" [sponsor]="sponsors[sInfo.sponsorId]" [bold]="true"></sponsor-card>
    </ng-container>
  </div>
</ng-container>
<ng-container *ngIf="staticSponsorIds">
  <ng-container *ngFor="let id of staticSponsorIds">
    <div *ngIf="sponsors[id] as sponsor">{{ sponsor.name }}</div>
  </ng-container>
</ng-container>